import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";
import { title } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function useUsersList() {
  // Use toast
  const toast = useToast();

  const refUserListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "img", label: "Avatar", sortable: false },
    { key: "rank", label: "Ranking", sortable: false },
    { key: "id", label: "Id Employee", sortable: false },
    { key: "name", sortable: false },
    { key: "total_sales_product", label: "Sales Total", sortable: true },
    { key: "total_pay_product", label: "Commission Products", sortable: true },
    { key: "total_sales_service", label: "Services Total", sortable: true },
    { key: "total_pay_service", label: "Commission Service", sortable: true },
    { key: "total_pay_tips", label: "Tips", sortable: true },
    { key: "totalc", label: "Commission Total", sortable: true },
    { key: "totalcandt", label: "Commission & Tips Total", sortable: true },
    // { key: "actions" },
  ];
  const perPage = ref(10);
  const totalUsers = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("totalcandt");
  const isSortDirDesc = ref(true);
  const roleFilter = ref(null);
  const statusFilter = ref(null);
  const itemsOffices = ref([]);
  const itemsStatus = ref([]);
  const rangeDateFilter = ref(null);
  const parser = JSON.parse(localStorage.getItem("userData"));
  const idOffice = ref(parser.dataUser.officeEmployee_officeId);
  const idRol = ref(parser.userData.rolId);

  const roleFilter1 = ref(null);
  const itemsOfficesFilter = ref([]);

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value
      ? refUserListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    };
  });

  const refetchData = () => {
    refUserListTable.value.refresh();
  };

  watch(
    [
      currentPage,
      perPage,
      searchQuery,
      roleFilter,
      statusFilter,
      rangeDateFilter,
      idOffice,
      idRol,
      roleFilter1,
    ],
    () => {
      console.log("desde watch");
      refetchData();
    }
  );

  const fetchUsers = (ctx, callback) => {
    const parser = JSON.parse(localStorage.getItem("userData"));
    store
      .dispatch("app-user/fetchPaymamentEmployees", {
        q: searchQuery.value.toLowerCase(),
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        employeeId:
          idRol.value !== 4 ? roleFilter.value : parser.dataUser.Employeess_id,
        customerId: statusFilter.value,
        rangeDate: rangeDateFilter.value,
        idOffice: idOffice.value,
        idRol: idRol.value,
        idOfficeFilter: roleFilter1.value,
      })
      .then((response) => {
        const { paymentEmployees, total } = response.data;

        callback(paymentEmployees);
        totalUsers.value = total;
        const arrayOffice = [];
        const arrayData = [];
        const setObj = new Set();
        const setObjOffice = new Set();

        if (idRol.value !== 4) {
          paymentEmployees.map((data, item) => {
            arrayOffice.push({
              label: data.name,
              value: data.id,
            });
          });
        } else {
          arrayOffice.push({
            label: parser.fullName,
            value: parser.dataUser.Employeess_id,
            id: parser.dataUser.Employeess_id,
          });
        }

        const arrayOfficeData = [
          {
            label: "MELA BEAUTY DORAL",
            value: 1,
          },
          { label: "MELA BEAUTY SUNNY ISLES", value: 2 },
        ];

        itemsOffices.value = arrayOffice;
        itemsOfficesFilter.value = arrayOfficeData;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching users list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = (role) => {
    if (role === "subscriber") return "primary";
    if (role === "author") return "warning";
    if (role === "maintainer") return "success";
    if (role === "editor") return "info";
    if (role === "admin") return "danger";
    return "primary";
  };

  const resolveUserRoleIcon = (role) => {
    if (role === "subscriber") return "UserIcon";
    if (role === "author") return "SettingsIcon";
    if (role === "maintainer") return "DatabaseIcon";
    if (role === "editor") return "Edit2Icon";
    if (role === "admin") return "ServerIcon";
    return "UserIcon";
  };

  const resolveUserStatusVariant = (status) => {
    if (status === true) return "success";
    if (status === false) return "warning";
    return "success";
  };

  const dataItemOffice = itemsOffices;
  const dataItemStatus = itemsStatus;
  const dataOfficeFilter = itemsOfficesFilter;

  return {
    fetchUsers,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    statusFilter,
    dataItemStatus,
    dataItemOffice,
    rangeDateFilter,
    idOffice,
    idRol,
    roleFilter1,
    dataOfficeFilter,
  };
}
